import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const PublicWebsite = () => {
  const { slug } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Redirect to the backend HTML endpoint for full-page rendering
    const htmlUrl = `${process.env.REACT_APP_BACKEND_URL}/api/sites/${slug}/html`;
    window.location.href = htmlUrl;
  }, [slug]);

  if (error) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-white mb-4">404</h1>
          <p className="text-zinc-400">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-violet-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-zinc-400">Loading website...</p>
      </div>
    </div>
  );
};

export default PublicWebsite;
